const SHRINK_THRESHOLD = 60;
const SCROLLED_CLASS = 'nav-scrolled';

/**
 * Toggles a `.nav-scrolled` class on <nav> once the user scrolls past the
 * threshold. All visual response (height, border, logo size) lives in CSS —
 * this module only owns the class toggle.
 */
export function initNavScroll(selector = 'nav') {
  const nav = document.querySelector(selector);
  if (!nav) return;

  const apply = () => {
    nav.classList.toggle(SCROLLED_CLASS, window.scrollY > SHRINK_THRESHOLD);
  };

  apply();
  window.addEventListener('scroll', apply, { passive: true });
}
